import {
  FormHelperText,
  InputAdornment,
  OutlinedInput,
  useScrollTrigger,
} from "@material-ui/core";
import React, {
  Component,
  Fragment,
  useContext,
  useEffect,
  useState,
} from "react";
// import { DeletePopup } from "../../../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
import SlidingComponent from "../../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import SuperAdminProfilePopup from "../../../superAdminReusable/reusablePopupSuperAdmin/superadminprofilepopup/SuperAdminProfilePopup";
import { SuperAdminTopSearchIcon } from "../../../superAdminReusable/reusableTable/SuperAdminTopTextSearchIcon";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { TableBodyRefree } from "./RefreeTables/TableBodyRefree";
import TableheadRefree from "./RefreeTables/TableheadRefree";
import Alert from "react-s-alert";
import AddReferreePopup from "../referralsPopup/AddReferreePopup";
import {
  superadmin_refrees_get,
  superadmin_refrees_delete,
  superadmin_refrees_change_status,
} from "../../../../../store/actions/SuperAdminActions/superadminreferralsaction";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";

import SelectFilter from "../../../../reusableComponents/selectFilter";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import { Table, Form, Col, Row, Modal, Image } from "react-bootstrap";
import { MenuItem } from "@material-ui/core";
import {
  FilterMain,
  SearchWithIconInput,
  SortTopRight,
} from "../InsidePages/ReferralUserComponent";
import CSVDownloader from "../../../../reusableComponents/csvDownload/csvDownload";
class SuperAdminRefrees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refreesData: [],
      sort: 1,
      filterValue: "",
      filterValueChecked: "",
      search: "",
    };
  }
  componentDidMount() {
    const token = this.props.auth.user.accessToken;
    this.props.superadmin_refrees_get(token);

    this.setState({
      refreesData: this.props.refreesData ? this.props.refreesData : [],
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.refreesData &&
      this.state.refreesData.length !== nextProps.refreesData &&
      nextProps.refreesData.length
    ) {
      this.setState({ refreesData: nextProps.refreesData });
    }
  }
  onDeleteUser = (id, openModal) => {
    const token = this.props.auth.user.accessToken;
    this.props.superadmin_refrees_delete(token, id, (e) => {
      openModal();
      this.props.superadmin_refrees_get(token);
      Alert.success(`<h4>Refree deleted successfully.</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    });
  };
  changeStatusRefree = (_id, current) => {
    const token = this.props.auth.user.accessToken;
    this.props.superadmin_refrees_change_status(
      token,
      _id,
      { active: !current },
      (e) => {
        this.props.superadmin_refrees_get(token);
        Alert.success(`<h4>Refree status changed successfully.</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    );
  };
  renderTableDataBody = () => {
    const refrees = this.state.refreesData;
    const { status_filterChecked, filterValueChecked, search } = this.state;
    return (
      <React.Fragment>
        {refrees
          .filter((e) => {
            if (filterValueChecked !== "") {
              return e.role === filterValueChecked;
            } else {
              return true;
            }
          })
          .filter((e) => {
            if (search) {
              return (
                e?.referral_code?.toString()?.includes(search) ||
                e?.name?.toString()?.includes(search)
              );
            }
            return true;
          })
          .filter((e) => {
            if (status_filterChecked === "Active") {
              return e.active === true;
            } else if (status_filterChecked === "InActive") {
              return e.active === false;
            }
            return true;
          })
          .map((data) => (
            <TableBodyRefree
              id={data._id}
              //   src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
              userName={data.name}
              number={data.country_code + data.mobile_number}
              referralCode={data.referral_code}
              refree={{
                src: data.profile_photo,
                name: data.name,
              }}
              referred={{
                src: require("../../../../../assets/images/ActionImages/demoprofile.jpg"),
                name: "Kelly McDonald",
              }}
              email={data.email}
              refereeRole={data.role}
              referalRole="User"
              refDate={new Date()}
              enrollDate={new Date()}
              lastActivity={"Sign Up"}
              referralQualified="Yes"
              lastActivityReferree={new Date()}
              amount="₹ 2200"
              receivingOrgID="123456"
              receivingOrgName="XXXXXXXXXX"
              amountDisburse="₹ 220"
              status={
                <div className="d-flex ">
                  <div className="f10-500 mr-3">
                    {data.active ? "Active" : "Inactive"}
                  </div>
                  <SlidingComponent
                    name="status"
                    checked={data.active}
                    currentState={data.active}
                    type={"checkbox"}
                    toggleclass={
                      "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                    }
                    toggleinputclass={
                      "toggle__switch vendor-super-admin-toggle"
                    }
                    onChange={() => {
                      this.changeStatusRefree(data._id, data.active);
                    }}
                    // slidingonClick={this.onSelecttogglestatusChange(data)}
                    defaultChecked={true}
                  />
                </div>
              }
              actions={<Actions onDeleteUser={this.onDeleteUser} data={data} />}
            />
          ))}
      </React.Fragment>
    );
  };
  render() {
    const downloadData = {
      headers: [
        { label: "ID", key: "id" },
        { label: "Name", key: "name" },
        { label: "Phone Number", key: "phone_number" },
        { label: "Email Address", key: "email" },
        { label: "Role", key: "role" },
        { label: "Status", key: "status" },
      ],
      data: this.state.refreesData
        ? this.state.refreesData?.map((ele) => {
            return {
              id: ele?._id,
              name: ele?.name,
              phone_number: ele?.country_code + ele?.mobile_number,
              email: ele?.email,
              role: ele?.role,
              status: ele?.active ? "Active" : "Inactive",
            };
          })
        : [],
    };
    return (
      <Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation
                displayText="All Referrals Code"
                displayButton="addReferrals"
              />
              <div className="super-admin-inside-right-side-panel">
                <div className="seating_dashboard_top_new_header">
                  <div className="row">
                    <div className="col-6">
                      <h4>Referees</h4>
                    </div>
                    <div className="col-6 text-right">
                      <AddReferreePopup />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-3">
                      {/* <SuperAdminTopSearchIcon displayIcon={true} /> */}
                      <SearchWithIconInput
                        onChange={(e) =>
                          this.setState({ search: e.target.value })
                        }
                        search={this.state.search}
                      />
                    </div>
                    <div className="col-4 p-0"></div>
                    <div className="col-2">
                      {/* <div className="mr-3">
                        <SelectFilter
                          onDateChange={this.onDateChangeHandler()}
                        />
                      </div> */}
                    </div>
                    <div className="col-2">
                      <div className="d-flex align-items-center justify-content-between cursor-pointer">
                        <SortTopRight
                          // setSort={this.setSort}
                          filterItems={[
                            { title: "Referred Date & Time", disabled: true },
                            { title: "Old to New", disabled: false },
                            { title: "New to Old", disabled: false },
                            // { title: "User Activity", disabled: true },
                            // { title: `Date & Time 🠑`, disabled: false },
                            // { title: "Date & Time 🠓", disabled: false },
                          ]}
                        />
                        <div
                          className="f10-400"
                          align="center"
                          onClick={() =>
                            this.setState({ filter: !this.state.filter })
                          }
                        >
                          <img
                            src={require("../../../../../assets/images/iconButton/filterbtn.svg")}
                            width="80px"
                          />
                          <br />
                          {/* Filter */}
                        </div>

                        <div className="f10-400" align="center">
                          <CSVDownloader
                            filename={"superadmin-refrees Report"}
                            headers={downloadData.headers}
                            data={downloadData.data}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <FilterMain
                    filterOptions={
                      <Row>
                        <Col md={6}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                Role
                              </InputLabel>
                              <Select
                                value={this.state.filterValue}
                                onChange={(e) =>
                                  this.setState({ filterValue: e.target.value })
                                }
                                label="Role"
                                inputProps={{
                                  name: "Role",
                                  id: "outlined-Status",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {["Sales", "Affiliates", "Partners"].map(
                                  (item, index) => (
                                    <MenuItem
                                      label={item}
                                      value={item}
                                      key={index}
                                    >
                                      {item}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Status">
                                Status
                              </InputLabel>
                              <Select
                                value={this.state.status_filter}
                                onChange={(e) =>
                                  this.setState({
                                    status_filter: e.target.value,
                                  })
                                }
                                label="Status"
                                inputProps={{
                                  name: "Status",
                                  id: "outlined-Status",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {["Active", "InActive"].map((item, index) => (
                                  <MenuItem
                                    label={item}
                                    value={item}
                                    key={index}
                                  >
                                    {item}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                      </Row>
                    }
                    show={this.state.filter}
                    onCancel={() => this.setState({ filter: false })}
                    onFilter={() =>
                      this.setState({
                        filterValueChecked: this.state.filterValue,
                        status_filterChecked: this.state.status_filter,
                      })
                    }
                  />
                  <div className="container-fluid ">
                    {/* <Row>
                      <div className="col-3 ">
                        <FormControl label="Search" variant="outlined">
                          <OutlinedInput
                            id="outlined-adornment-weight"
                            // value={values.weight}
                            // onChange={handleChange("weight")}
                            endAdornment={
                              <InputAdornment position="end">
                                <i className="fa fa-search"></i>
                              </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                            inputProps={{
                              "aria-label": "weight",
                            }}
                            // labelWidth={0}
                          />
                        </FormControl>
                      </div>
                    </Row> */}
                    <div
                      className={`col-12 p-0 user-table-reusable-superadmin `}
                    >
                      <Table>
                        <thead>
                          <TableheadRefree
                            headOne="ID"
                            headTwo="Name"
                            headThree="Phone Number"
                            headFour="Email Address"
                            headFive="Role"
                            headSix="Status"
                            headSeven="Action"
                          />
                        </thead>
                        <tbody>{this.renderTableDataBody()}</tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

// export default SuperAdminRefrees;

const RefereeViewModel = (props) => {
  const [open, setOpen] = React.useState(false);
  const openModal = () => {
    props.setShow(2);
  };
  const closeModal = () => {
    props.setShow(0);
  };
  useEffect(() => {
    setOpen(props.show);
  }, [props.show]);
  return (
    <React.Fragment>
      <div>
        <div className="super-admin-icon-box-width" style={{ fontSize: 20 }} 
              onClick={openModal}>
          {props.src ? (
            <Image
              src={
                // props.src
                // ?
                require("../../../../../assets/images/OfferAndEventImages/edit.png")
                // : require("../../../../../assets/images/OfferAndEventImages/view.png")
              }
              alt="View Icon"
              title="View Profile"
              fluid
            />
          ) : (
            <i class="fa fa-eye" aria-hidden="true"></i>
          )}
        </div>
        <Modal show={open} onHide={closeModal} centered>
          <Modal.Header className="py-0 pt-3 border-0" closeButton>
            <Modal.Title className="f24-700">Referral Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-6">
                <div className="pr-2 d-flex py-3">
                  <div className="user-profile-image mr-2">
                    {props && props.data && props.data.profile_photo ? (
                      <Image
                        fluid
                        className="h-100"
                        src={props.data.profile_photo}
                      />
                    ) : (
                      <Image
                        fluid
                        src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                      />
                    )}
                  </div>
                  <div className="w-100">
                    <div className="f16-700">{props.data.name}</div>
                    <div className="f11-500 mb-1">{props.data.role}</div>
                  </div>
                </div>
              </div>
              <div className="col-6 d-flex justify-content-end">
                {" "}
                <div className="super-admin-icon-box-width mr-2">
                  <Image
                    src={require("../../../../../assets/images/ActionImages/delete.png")}
                    alt="View Icon"
                    title="View Profile"
                    fluid
                    onClick={() => props.setShow(1)}
                  />
                </div>
                <div className="super-admin-icon-box-width">
                  <Image
                    src={require("../../../../../assets/images/OfferAndEventImages/edit.png")}
                    alt="View Icon"
                    title="View Profile"
                    fluid
                    onClick={() => props.setShow(3)}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-5">
                Email
                <br />
                <span className="f12-700" style={{ wordWrap: "break-word" }}>
                  {props.data.email}
                </span>
              </div>
              <div className="col-4">
                Phone
                <br />
                <span className="f12-700">
                  {props.data.country_code} {props.data.mobile_number}
                </span>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </React.Fragment>
  );
};

const DeletePopup = (props) => {
  const [open, setOpen] = React.useState(false);
  const openModal = () => {
    props.setShow(1);
  };
  const closeModal = () => {
    props.setShow(0);
  };
  useEffect(() => {
    setOpen(props.show);
  }, [props.show]);
  return (
    <React.Fragment>
      <div>
        <div
          className="super-admin-icon-box-width"
          style={{ fontSize: 20 }}
          onClick={openModal}
        >
          {props.src ? (
            <Image
              src={
                require("../../../../../assets/images/OfferAndEventImages/edit.png")
                // : require("../../../../../assets/images/ActionImages/delete.png")
              }
              alt="View Icon"
              title="View Profile"
              fluid
            />
          ) : (
            <i class="fa fa-trash" aria-hidden="true"></i>
          )}
        </div>
        <Modal show={open} onHide={closeModal} centered>
          <Modal.Header className="py-0 pt-3 border-0" closeButton>
            <Modal.Title className="f18-700">{props.displayText}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="d-flex align-items-center ">
              <button
                type="button"
                class="mr-4 px-5 py-2 btn btn-outline-secondary"
                onClick={() => closeModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                class="px-5  py-2 btn btn-danger"
                onClick={() => props.onDeleteUser(props._id, closeModal)}
              >
                Yes
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </React.Fragment>
  );
};

const Actions = (props) => {
  const [show, setShow] = useState(0);
  return (
    <div className="d-flex align-items-center">
      <div className="mr-4">
        <DeletePopup
          displayText="Are you sure you want to delete this referee?"
          buttonDisplay="superAdminDeleteIcon"
          onDeleteUser={props.onDeleteUser}
          _id={props.data._id}
          show={show === 1 ? true : false}
          setShow={(e) => setShow(e)}
        />
      </div>
      <div className="mr-4">
        <RefereeViewModel
          data={props.data}
          onDeleteUser={props.onDeleteUser}
          show={show === 2 ? true : false}
          setShow={(e) => {
            setShow(2);
            setShow(e);
          }}
        />
      </div>
      <div className="mr-4">
        <AddReferreePopup
          withIcon={true}
          show={show === 3 ? true : false}
          data={props.data}
          setShow={(e) => setShow(e)}
        />
      </div>
    </div>
  );
};

SuperAdminRefrees.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  refreesData: state.superAdminReferrals.refrees,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_refrees_get,
  superadmin_refrees_delete,
  superadmin_refrees_change_status,
})(withRouter(SuperAdminRefrees));
